<template>
  <section class="home">
    <section class="page-section clearfix">
      <div class="container">
        <div class="intro">
          <img
            class="intro-img img-responsive mb-3 mb-lg-0 rounded"
            src="@/assets/img/nursena.jpg"
            alt="Fabio left-right"
          />
          <div class="intro-text left-0 text-center bg-faded p-5 rounded">
            <h2 class="section-heading mb-4">
              <span class="section-heading-upper">My name is</span>
              <span class="section-heading-lower">Fabio Costa</span>
            </h2>
            <p class="mb-3">
              I'm a Chemistry graduate, but I cultivated a passion for IT
              programming. This passion made me apply to an IT programming
              course, which started the idea of being a programmer as a job
              career. I strive to live new experiences to refine my skills or to
              start developing new ones. I live in Cagliari (Italy), but I have
              been in many places around Europe. I'm a bit of a workaholic but I
              know well how far I can push myself. My philosophy is centered
              around the concept of "Emotional Intelligence". Want to know more
              about me?
            </p>
            <div class="intro-button mx-auto">
              <router-link tag="a" to="/about" class="btn btn-primary btn-xl"
                >Click here!</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section cta margin-expanded">
      <div class="container">
        <div class="row">
          <div class="col-xl-9 mx-auto">
            <div class="cta-inner text-center rounded">
              <h2 class="section-heading mb-4">
                <span class="section-heading-upper"
                  >What you can expect when I work</span
                >
                <span class="section-heading-lower">With you</span>
              </h2>
              <p class="mb-0">
                I always aim for the best working atmosphere I can achieve, both
                for me and my co-workers. I work efficiently both in a team and
                alone. I am independent and self-critical when needed and I
                consider the efficiency of my work the number one priority in
                the workplace.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
// @ is an alias to /src

export default {
  data: function () {
    return {
      number: 0,
    };
  },
  name: "Home",
  components: {},
};
</script>

<style lang="scss">
.img-responsive {
  max-width: 15rem;
}
.text-responsive {
  font-size: 1rem;
}
@media (min-width: 330px) {
  .img-responsive {
    max-width: 20rem;
  }
}
@media (min-width: 768px) {
  .img-responsive {
    max-width: 40rem;
  }
}

.margin-expanded {
  margin-top: 5rem;
}

@media (min-width: 75em) {
  .margin-expanded {
    margin-top: 9rem;
  }
}

.cta {
  padding-top: 5rem;
  padding-bottom: 5rem;
  background-color: fade-out($cyan, 0.1);
  .cta-inner {
    position: relative;
    padding: 3rem;
    margin: 0.5rem;
    background-color: fade-out($white, 0.15);
    &:before {
      border-radius: 0.5rem;
      content: "";
      position: absolute;
      top: -0.5rem;
      bottom: -0.5rem;
      left: -0.5rem;
      right: -0.5rem;
      border: 0.25rem solid fade-out($white, 0.15);
      z-index: -1;
    }
  }
}
.btn-xl {
  font-weight: 700;
  font-size: 0.8rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
}

.intro {
  position: relative;
  @media (min-width: 992px) {
    .intro-img {
      width: 75%;
      float: right;
    }
    .intro-text {
      left: 0;
      width: 60%;
      margin-top: 3rem;
      position: absolute;
      .intro-button {
        width: 100%;
        left: 0;
        position: absolute;
        bottom: -2rem;
      }
    }
  }
  @media (min-width: 1200px) {
    .intro-text {
      width: 45%;
    }
  }
}
</style>
